import React, { useCallback, useMemo, useState } from 'react';
import { SelectedSaleAnswer } from '../types/SalesTypes';
import {
  FORM_SALE_COLUMNS,
  buildFlattenedRows,
  defaultColumnWidths,
} from '../salesUtils';
import { WindowedSaleTable } from './WindowedSaleTable';
import { SetAllDiscountsButton } from './SetAllDiscountsButton';
import styles from './SalesTable.module.scss';

interface SelectedAnswersTableProps {
  selectedAnswers: SelectedSaleAnswer[];
  disabled?: boolean;
  onDiscountChange: (key: string, discountPercent: number) => void;
  onSetAllDiscounts: (discountPercent: number) => void;
}

export function SelectedAnswersTable(props: SelectedAnswersTableProps) {
  const { selectedAnswers, disabled, onDiscountChange, onSetAllDiscounts } = props;

  const [columnWidths, setColumnWidths] = useState(() => defaultColumnWidths(FORM_SALE_COLUMNS));

  const flattenedRows = useMemo(
    () => buildFlattenedRows(selectedAnswers),
    [selectedAnswers],
  );

  const handleColumnWidthChange = useCallback((columnId: string, width: number) => {
    setColumnWidths((prev) => ({ ...prev, [columnId]: width }));
  }, []);

  if (selectedAnswers.length === 0) {
    return (
      <p className="text-muted mb-0">No answers selected. Use Select answers to choose priced answers.</p>
    );
  }

  return (
    <div className={styles.formTableWrap}>
      <WindowedSaleTable
        flattenedRows={flattenedRows}
        columns={FORM_SALE_COLUMNS}
        columnWidths={columnWidths}
        onColumnWidthChange={handleColumnWidthChange}
        onDiscountChange={onDiscountChange}
        discountDisabled={disabled}
        discountColumnHeaderSlot={(
          <SetAllDiscountsButton
            disabled={disabled}
            onApply={onSetAllDiscounts}
          />
        )}
      />
    </div>
  );
}
